.contentWrapper {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0;
  gap: 32px;
}
